export default __webpack_public_path__ + "static/media/allocation.3f7110b9.png";